import { useMutation } from '@tanstack/react-query'

import { api } from '@/lib/axios'
import { queryClient } from '@/lib/tanstack'

async function disconnectApplicationAccountUsersAuth(id: string) {
  await api.backend.delete(`/application-account-users-auth/${id}`)
}

export function useDisconnectApplicationAccountUsersAuth() {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['/application-account-users-auth/delete'],
    mutationFn: disconnectApplicationAccountUsersAuth,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/user/current-accounts'] })
      queryClient.refetchQueries({ queryKey: ['/user/get-user-info'] })
    },
  })

  const handleDisconnectApplicationAccountUsersAuth = async (id: string) => {
    return mutateAsync(id)
  }

  return {
    handleDisconnectApplicationAccountUsersAuth,
    isDisconnectingApplicationAccountUsersAuth: isPending,
  }
}
